import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function CheckIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M19.293 5.293a1 1 0 1 1 1.414 1.414l-11 11a1 1 0 0 1-1.414 0l-5-5a1 1 0 1 1 1.414-1.414L9 15.586z" />
    </Icon>
  );
}

CheckIcon.displayName = 'CheckIcon';
